enum TransactionTypeEnum {
    Deposit = 'DEPOSIT',
    LoanIssued = 'LOAN_ISSUED',
    Withdrawal = 'WITHDRAWAL',
    Payment = 'PAYMENT',
}

export default TransactionTypeEnum;
